import { render, staticRenderFns } from "./Sitewide.vue?vue&type=template&id=09aa8b60&scoped=true&lang=pug&"
import script from "./Sitewide.vue?vue&type=script&lang=js&"
export * from "./Sitewide.vue?vue&type=script&lang=js&"
import style0 from "./Sitewide.vue?vue&type=style&index=0&id=09aa8b60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa8b60",
  null
  
)

export default component.exports